import React, { useContext } from 'react';
import { Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { CLIENT_ID } from '../../config/google';
import { NecttosContext } from '../../context/NecttosContext';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { Table, Th, Thead } from '../../NecttosComp/Table/Table';

const getDetails = async (collegeId, userId) => {
	const instance = await getAxiosTokenInstance();
	try {
		const { data, status } = await instance.get(`/google/backupDetails`, {
			params: {
				collegeId,
				userId,
			},
		});
		if (status === 200) {
			return data;
		} else {
			console.error('Error fetching details:', data);
			return null;
		}
	} catch (error) {
		console.error('Error fetching details:', error);
	}
};

function BackUp({ onClose }) {
	const { collegeId, userId } = useContext(NecttosContext);
	const { data } = useQuery(['googleBackup', collegeId, userId], () => getDetails(collegeId, userId), {
		enabled: !!collegeId && !!userId,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		refetchOnMount: false,
	});

    const account = data?.data
    const backupStats = data?.backupStats

	const handleLogin = () => {
		const scope = encodeURIComponent('https://www.googleapis.com/auth/drive.file openid email profile');
		const state = encodeURIComponent(JSON.stringify({ collegeId, userId }));
		const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent('http://localhost:2900/google/callback')}&response_type=code&scope=${scope}&access_type=offline&prompt=consent&state=${state}`;
		const width = 500;
		const height = 600;
		const left = window.screenX + (window.outerWidth - width) / 2;
		const top = window.screenY + (window.outerHeight - height) / 2;
		const popup = window.open(url, 'GoogleOAuth', `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`);
		const listener = (event) => {
			if (event.origin !== window.location.origin) return;
			if (event.data === 'google-auth-success') {
				window.removeEventListener('message', listener);
				if (popup) popup.close();
				window.location.reload();
			}
			if (event.data === 'google-auth-fail') {
				window.removeEventListener('message', listener);
				if (popup) popup.close();
				alert('Google authentication failed.');
			}
		};
		window.addEventListener('message', listener);
	}

	return (
		<Main title='Google' width='40%' height='40%' className='relative bg-gray-50 dark:bg-gray-900 p-6 rounded-lg shadow-lg'>
			<Header className='flex justify-between items-center mb-6'>
				{!account?.collegeId || data?.sameUser && (
					<button onClick={handleLogin} className='px-5 py-3 text-lg font-semibold rounded-md bg-blue-600 hover:bg-blue-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-400 transition' aria-label='Login with Google'>
						Login with Google
					</button>
				)}
				<Button type='close' onClick={onClose} className='text-white bg-red-600 hover:bg-red-700 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-400 transition' aria-label='Close session'>
					Close
				</Button>
			</Header>
			<section className='bg-yellow-100 dark:bg-yellow-900 border-l-4 border-yellow-500 p-4 rounded-md'>
				<h2 className='text-xl font-bold mb-2 text-yellow-800 dark:text-yellow-300'>Important Security Notice</h2>

				<p className='text-yellow-700 dark:text-yellow-200'>For your security, all Google login sessions use encrypted token storage and multi-factor authentication options. Necttos also performs regular secure backups of your session data and settings to ensure quick recovery in case of issues.</p>

                

			</section>
		</Main>
	);
}

export default BackUp;
